import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const abs = (u) => (!u ? u : u.startsWith("http") ? u : `${BACKEND}${u}`);

// Admin-curated page images (Admin → Page Images) with per-slot fallbacks.
export function usePageImages(pageKey, defaults) {
  const [slots, setSlots] = useState({});
  useEffect(() => {
    api.get(`/page-images/${pageKey}`).then(({ data }) => setSlots(data.slots || {})).catch(() => {});
  }, [pageKey]);
  return (key) => abs(slots[key]?.[0] || defaults[key]);
}
